import { render, staticRenderFns } from "./bulk-creation-inputs.vue?vue&type=template&id=1c5432ce&scoped=true&"
import script from "./bulk-creation-inputs.vue?vue&type=script&lang=js&"
export * from "./bulk-creation-inputs.vue?vue&type=script&lang=js&"
import style0 from "./bulk-creation-inputs.vue?vue&type=style&index=0&id=1c5432ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5432ce",
  null
  
)

export default component.exports